"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SHOW_MODAL = exports.CLEAR_MODAL = void 0;
var SHOW_MODAL = exports.SHOW_MODAL = 'SHOW_MODAL';
var CLEAR_MODAL = exports.CLEAR_MODAL = 'CLEAR_MODAL';